module.exports = __webpack_public_path__ + "static/img/dzb.8631312b.png";